module.exports = __webpack_public_path__ + "img/logo_mw_social_white_small.4f4fe064.png";